import { useState, useEffect } from 'react';
import "./QuestionComments.css";
import { QuestionComment } from 'effno-core';
import { CommentCard } from '../comment/CommentCard';
import { useSelector } from 'react-redux';
import { selectEditingForm, selectEditingQuestionId, setEditingForm } from '../../redux/features/appData';
import { apiDeleteCommentAndChildren } from '../../services/CommentService';
import toast from 'react-hot-toast';
import { toastFail } from '../../config';
import { useDispatch } from 'react-redux';

type QuestionCommentsProps = {
    // comments: QuestionComment[];
}

export const QuestionComments = ({} : QuestionCommentsProps) => {

    const dispatch = useDispatch();

    const editingForm = useSelector(selectEditingForm);
    const editingQuestionId = useSelector(selectEditingQuestionId);

    const [comments, setComments] = useState<QuestionComment[]>([]);

    useEffect(() => {   
        if (editingForm && editingQuestionId) {
            const editingQuestion = editingForm.questions.find((question) => 
                question.id === editingQuestionId);

            if (!editingQuestion) {
                return;
            }

            setComments(editingQuestion.comments);
        }

    }, [editingForm, editingQuestionId]); 

    const handleComplete = async (commentId: string) => {   
        console.log("[QuestionComments/handleComplete] commentId: ", commentId);
        if (!editingForm || !editingQuestionId) {
            console.error("[QuestionComments/handleComplete] Editing form not found");
            return;
        }

        const numberDeletes = await apiDeleteCommentAndChildren(commentId);

        // console.log("[Comment/handleComplete] numberDeletes: ", numberDeletes);

        if (!numberDeletes || numberDeletes < 1) {
            console.error("[QuestionComments/handleComplete] Error checking comment");
            return;
        }

        // update editing form - redux
        const questionIndex = editingForm.questions.findIndex((question) => question.id === editingQuestionId);

        if (questionIndex === -1) {
            toast("Error checking comment, can't find question", toastFail);
            return;
        }

        const newQuestions = [...editingForm.questions];
        const remainingComments = newQuestions[questionIndex].comments.filter((c) => {
            return (c.id !== commentId) && (c.parentQuestionCommentId !== commentId)
        })
        const newComments = [...remainingComments]
        const newQuestion = {...newQuestions[questionIndex], comments: newComments}
        newQuestions[questionIndex] = newQuestion;
        const newForm = {...editingForm, questions: newQuestions};
        dispatch(setEditingForm(newForm));
    }

    const handleReply = (id: string, text: string) => {
        console.log("[QuestionComments/handleReply] id: ", id);
        console.log("[QuestionComments/handleReply] text: ", text);
    }

    const parentComments = comments.filter((comment) => !comment.parentQuestionCommentId);


    return (
        <div className="question-comments">
            <div className="question-comments-title">
                Comments
            </div>
            {parentComments.map((comment : QuestionComment) => {
                return (
                    <CommentCard 
                        comments={comments}
                        comment={comment}
                        allowReply={false}
                        onComplete={handleComplete}
                        onReply={handleReply}
                    />
                )})
            }
            {parentComments && parentComments.length === 0 &&
                <div className="question-comments-empty">
                    No comments on this question
                </div>
            }
        </div>
    )
}